import { Col, message, Row } from "antd";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import {
  ReplacementTransportPlanFormCard,
  ReplacementTransportPlanInputDto,
} from "./components/ReplacementTransportPlanFormCard";
import {
  fetchReplacementTransportPlanById,
  updateReplacementTransportPlanById,
} from "../../../../lib/api/resources/replacementTransports";

export const ReplacementTransportPlanEdit = () => {
  const { id } = useParams();

  if (!id) return null;
  const navigate = useNavigate();

  const replacementTransportPlanQuery = useQuery({
    queryKey: ["replacementTransportPlan", id],
    queryFn: async () => fetchReplacementTransportPlanById(id),
    select: (data) => {
      const options = data.options.member.map((option) => option.option.id);
      return {
        options,
        companyId: data.company?.id || null,
        dossierTypeId: "",
        priority: data.priority,
      };
    },
  });

  const updateReplacementTransportPlanMutation = useMutation({
    mutationFn: (data: ReplacementTransportPlanInputDto) =>
      updateReplacementTransportPlanById(id, data),
    onSuccess: () => {
      navigate(`/replacement-transport/plans/${id}`);
      message.success("Vervangend vervoer plan succesvol bijgewerkt");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het bijwerken van het vervangend vervoer plan",
      ),
  });

  return (
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <ReplacementTransportPlanFormCard
          initialValues={replacementTransportPlanQuery.data}
          loading={replacementTransportPlanQuery.isLoading}
          mutation={updateReplacementTransportPlanMutation}
          title="Vervangend vervoer plan bewerken"
          buttonText="Bewerken"
        />
      </Col>
    </Row>
  );
};
